"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    bookingHeadWebId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      fileId: '',
      fileName: '',
      fileList: [],
      btnFlag: true
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isLtName = file.name.length < 40;
      if (!isLt2M) {
        this.$message.error(this.$t('home.uploadFiveInfo'));
      }
      if (!isLtName) {
        this.$message.error(this.$t('home.uploadSixInfo'));
      }
      return isLt2M && isLtName;
    },
    uploadFile: function uploadFile(item) {
      var _this = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      this.fileId = '';
      this.fileName = '';
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          // this.$message.success(this.$t("com.importSuccess"));
          _this.fileId = res.fileId;
          _this.fileName = res.fileName;
        } else {
          _this.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        if (_this.fileId && _this.fileName) {
          _this.btnFlag = false;
        } else {
          _this.fileList = [];
          _this.$refs.upload.clearFiles();
          _this.btnFlag = true;
          _this.$message.warning(_this.$t('selectMessage.uploadFail'));
        }
        _this.loading.close();
      });
    },
    handleUploadFile: function handleUploadFile() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      if (this.$refs.upload.uploadFiles.length === 0) {
        this.btnFlag = true;
        this.loading.close();
        return this.$message.warning(this.$t("home.selectFileWaring"));
      }
      if (!this.fileId && !this.fileName) {
        this.fileList = [];
        this.$refs.upload.clearFiles();
        this.btnFlag = true;
        this.loading.close();
        return this.$message.warning(this.$t('selectMessage.uploadFail'));
      }
      var data = {
        bookingHeadWebIds: this.bookingHeadWebId,
        fileId: this.fileId,
        fileName: this.fileName
      };
      // this.$refs.upload.submit();
      (0, _booking.searchReleaseHistoryUploadLog)(data).then(function (res) {
        if (res.success) {
          _this2.$message.success(_this2.$t("home.uploadTitleSuccess"));
          _this2.$parent.releaseImportDialogVisible = false;
        } else {
          _this2.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this2.fileList = [];
        _this2.loading.close();
        _this2.$parent.releaseImportDialogVisible = false;
        _this2.$refs.upload.clearFiles();
        _this2.$parent.handleSearch();
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 3 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    opened: function opened() {
      //   this.handleSearch()
      console.log('opened');
    }
  }
};